export const CategoryPath = '/category';
export const CategoryUrls = {
  page: CategoryPath,
  detail: `${CategoryPath}/category/:id`,
  getDetailPath: id => `${CategoryPath}/category/${id}`,
};
